// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__RuPi4","rightAdornment":"Header_rightAdornment__sKluY"};